import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.html',
  styleUrls: ['./sign-up.scss'],
  imports: [RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignUpComponent {
  public constructor(private readonly router: Router) {}
}
